<div class="gallery-item-container" [ngClass]="{ selected: selected, hovered: hovered, checked: checked }">
  <ng-content></ng-content>
  <div *ngIf="settings.showThumbnail" class="thumbnail">
    <u-icon
      *ngIf="thumbnail; else fallbackIcon"
      class="thumbnail-img"
      [model]="{ type: 'img', value: { lightUrl: thumbnail } }"
      [fallback]="iconOverlayModel?.value?.lightUrl || iconModel?.value?.lightUrl"
    ></u-icon>
  </div>

  <div class="actions-container">
    <div class="left-actions">
      <u-button
        *ngIf="settings.showDrag"
        class="actions drag"
        fontIcon="dragging-ind"
        type="secondary"
        pTooltip="Drag to move 
      Click to open menu"
        tooltipPosition="bottom"
        tooltipStyleClass="u-tooltip"
        [styles]="{ padding: '0', width: '12px', height: '12px', fontSize: '12px' }"
        (click)="$event.stopPropagation(); invoke.emit({ event: $event, type: 'contextmenu' })"
      >
        <ng-container *ngTemplateOutlet="dragItemTemplate"> </ng-container>
      </u-button>
      <u-checkbox
        *ngIf="settings.showCheckbox"
        class="actions checkbox"
        [checked]="checked"
        [isNoColor]="true"
        [binary]="true"
        (onChange)="invoke.emit({ event: $event, type: 'checkbox' })"
      ></u-checkbox>
    </div>

    <div class="right-actions">
      <ng-container *featureFlagEnabled="DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG">
        <u-icon class="favorite-icon" *ngIf="settings.showFavorite" [model]="{ type: 'font', value: 'icon-star-solid' }"></u-icon>
      </ng-container>
      <u-icon
        *ngIf="isPreviewClickAction(model?.action) && settings.showPreview"
        (click)="invoke.emit({ event: $event, type: 'preview' }); $event.stopPropagation()"
        class="actions"
        [model]="{ type: 'font', value: 'icon-eye' }"
        pTooltip="Preview"
        tooltipPosition="top"
        tooltipStyleClass="u-tooltip"
      ></u-icon>
      <u-icon
        *ngIf="settings.showSummary"
        class="actions"
        (mouseover)="invoke.emit({ event: $event, type: 'summary' })"
        [model]="{ type: 'font', value: 'icon-board-list' }"
      ></u-icon>
      <square-button
        class="actions"
        [active]="contextMenuActive"
        (click)="$event.stopPropagation(); invoke.emit({ event: $event, type: 'contextmenu' })"
        (auxclick)="$event.stopPropagation(); invoke.emit({ event: $event, type: 'contextmenu' })"
        (contextmenu)="$event.stopPropagation(); invoke.emit({ event: $event, type: 'contextmenu' })"
        >•••</square-button
      >
    </div>
  </div>

  <div
    *ngIf="settings.showFooter && model"
    class="gallery-footer"
    [ngStyle]="!settings.showInputTitle ? { cursor: 'pointer' } : {}"
    (click)="onClickFooter($event); $event.stopPropagation()"
  >
    <div class="icon-container">
      <u-icon *ngIf="model.view?.icon" [ngClass]="{ 'with-icon-overlay': model.view?.iconOverlay }" [model]="iconModel"></u-icon>
      <u-icon *ngIf="model.view?.iconOverlay" class="icon-overlay" [model]="iconOverlayModel"></u-icon>
    </div>
    <input-title
      *ngIf="settings.showInputTitle"
      [text]="model.view.title.text"
      [inputPlaceholder]="inputPlaceholder"
      [defaultInputModel]="model.type === 'collection-header' ? 'Header' : this.model.view.title.text"
      [inputModel]="model.view.title.text"
      [fontSize]="model.type === 'collection-header' ? 'large' : 'regular'"
      (onDisplayInput)="invoke.emit({ event: $event, type: 'onDisplayInput' })"
      (onBlurUInput)="invoke.emit({ event: $event, type: 'onBlurUInput' })"
      (onClickOut)="invoke.emit({ event: $event, type: 'onClickOut' })"
    >
    </input-title>
    <div
      *ngIf="!settings.showInputTitle"
      #title
      data-cy="title"
      class="title-text"
      [pTooltip]="tooltipTitleText"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
    >
      <span [innerHTML]="model.view?.title?.text | highlight: model.highlights : 'default'"></span>
    </div>
    <result-badge *ngIf="settings.showBadge && model.view.badge" [model]="model.view.badge"></result-badge>
    <div *ngIf="settings.showNewIndication" class="new-indication">
      <new-indication [tooltip]="settings.showNewIndication"></new-indication>
    </div>
  </div>
</div>

<ng-template #fallbackIcon>
  <div *ngIf="!thumbnail" class="fallback-icon">
    <u-icon *ngIf="iconOverlayModel" [model]="iconOverlayModel"></u-icon>
    <u-icon *ngIf="iconModel && !iconOverlayModel" [model]="iconModel"></u-icon>
  </div>
</ng-template>
